import { ScheduleModel } from '@/types';
import { BaseService } from '@/services';

class ScheduleService extends BaseService<ScheduleModel> {}

export default new ScheduleService('schedules');
